/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Data_Protection_TextInputs */

const en_agb_data_protection_text = /** @type {(inputs: Agb_Data_Protection_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We process personal data in accordance with the General Data Protection Regulation (GDPR) and German data protection law (BDSG). For full details, please see our`)
};

const de_agb_data_protection_text = /** @type {(inputs: Agb_Data_Protection_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir verarbeiten personenbezogene Daten in Uebereinstimmung mit der Datenschutz-Grundverordnung (DSGVO) und dem Bundesdatenschutzgesetz (BDSG). Alle Details finden Sie in unserer`)
};

const fr_agb_data_protection_text = /** @type {(inputs: Agb_Data_Protection_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous traitons les données personnelles conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi allemande sur la protection des données (BDSG). Pour tous les détails, consulte notre`)
};

const es_agb_data_protection_text = /** @type {(inputs: Agb_Data_Protection_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tratamos los datos personales de conformidad con el Reglamento General de Protección de Datos (RGPD) y la ley alemana de protección de datos (BDSG). Para más detalles, consulta nuestra`)
};

const it_agb_data_protection_text = /** @type {(inputs: Agb_Data_Protection_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trattiamo i dati personali in conformità con il Regolamento generale sulla protezione dei dati (GDPR) e la legge tedesca sulla protezione dei dati (BDSG). Per tutti i dettagli, consulta la nostra`)
};

const nl_agb_data_protection_text = /** @type {(inputs: Agb_Data_Protection_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wij verwerken persoonsgegevens in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG) en de Duitse wetgeving inzake gegevensbescherming (BDSG). Voor volledige details, zie ons`)
};

const pl_agb_data_protection_text = /** @type {(inputs: Agb_Data_Protection_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przetwarzamy dane osobowe zgodnie z Ogólnym Rozporządzeniem o Ochronie Danych (RODO) oraz niemiecką ustawą o ochronie danych osobowych (BDSG). Szczegóły znajdziesz w naszej`)
};

const fi_agb_data_protection_text = /** @type {(inputs: Agb_Data_Protection_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käsittelemme henkilötietoja yleisen tietosuoja-asetuksen (GDPR) ja Saksan tietosuojalain (BDSG) mukaisesti. Katso täydelliset tiedot`)
};

const da_agb_data_protection_text = /** @type {(inputs: Agb_Data_Protection_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi behandler persondata i overensstemmelse med den generelle forordning om databeskyttelse (GDPR) og den tyske databeskyttelseslov (BDSG). For alle detaljer, se venligst vores`)
};

const sv_agb_data_protection_text = /** @type {(inputs: Agb_Data_Protection_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi behandlar personuppgifter i enlighet med dataskyddsförordningen (GDPR) och tysk dataskyddslag (BDSG). För fullständig information, se vår`)
};

/**
* | output |
* | --- |
* | "We process personal data in accordance with the General Data Protection Regulation (GDPR) and German data protection law (BDSG). For full details, please see..." |
*
* @param {Agb_Data_Protection_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_data_protection_text = /** @type {((inputs?: Agb_Data_Protection_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Data_Protection_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_data_protection_text(inputs)
	if (locale === "fr") return fr_agb_data_protection_text(inputs)
	if (locale === "es") return es_agb_data_protection_text(inputs)
	if (locale === "it") return it_agb_data_protection_text(inputs)
	if (locale === "nl") return nl_agb_data_protection_text(inputs)
	if (locale === "pl") return pl_agb_data_protection_text(inputs)
	if (locale === "fi") return fi_agb_data_protection_text(inputs)
	if (locale === "da") return da_agb_data_protection_text(inputs)
	if (locale === "sv") return sv_agb_data_protection_text(inputs)
	return en_agb_data_protection_text(inputs)
});